import {ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, Output} from "@angular/core";
import {SsoConfigModel} from "../../../models/sso-config.model";
import {AuthZeroService} from "../../services/auth-zero.service";
import {PostLoginRedirectService} from "../../services/post-login-redirect.service";

@Component({
  standalone: false,
  selector: 'app-sso-login-button',
  templateUrl: './sso-login-button.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SsoLoginButtonComponent {

  @Input() config: SsoConfigModel;

  // initCodeFlow() below builds the redirect URL asynchronously (nonce/PKCE generation),
  // then the browser still has to load the IdP's page - both take a moment with no
  // visible feedback otherwise, so let the parent show its loading state meanwhile.
  @Output() loginStarted = new EventEmitter<void>();

  constructor(@Inject(AuthZeroService) private authZeroService: AuthZeroService,
              @Inject(PostLoginRedirectService) private postLoginRedirectService: PostLoginRedirectService) {

  }

  ngOnInit(): void {

  }

  login() {
    // Start login process via a full-page redirect. The popup flow (initLoginFlowInPopup)
    // is unreliable: browsers' Cross-Origin-Opener-Policy restrictions on the IdP's login
    // page intermittently block the popup-closed detection, silently killing the login.
    this.loginStarted.emit();

    localStorage.removeItem('admin_token');
    localStorage.removeItem('access_token');

    this.postLoginRedirectService.capturePreviousState();

    this.authZeroService.initCodeFlow();
  }


}
